import { LeadInput } from './leadInput';

export class GetSimulatedPotentialSellersInput {
  simulatedLeadInput: LeadInput;

  constructor(simulatedLeadInput: LeadInput) {
    this.simulatedLeadInput = simulatedLeadInput;
  }
}
